module.exports = __webpack_public_path__ + "static/media/ugpgBanner3.547a8905.png";